export default {
  setProgramUIState: (state, value) => state.programUIState = value
}